<script>
import {mapActions, mapGetters} from "vuex";
import {
  getBusinessCardsDoc,
  queryConnectionsCollection,
  queryEventAttendeesCollection
} from "@/shared/firebase_utils";
import {where, limit, getCountFromServer, getDocs, startAfter, query} from "firebase/firestore";
import Loading from "@/components/Loading.vue";

export default {
  name: "ConnectionsAnalyticsDetails",
  components: {Loading},
  data() {
    return {
      attendeeData: [],
      lastLoadedDocument: null,
      canLoadMore: true,
      currentEventId: null,
      headers: [
        {
          text: "",
          value: "image",
          align: "end",
        },
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        {
          text: "Business Name",
          value: "businessName",
          align: "start",
        },
        {
          text: "Job Title",
          value: "jobTitle",
          align: "start",
        },
        {
          text: "Connections requested",
          value: "connectionsRequested",
          align: "start",
        },
        {
          text: "Connections made",
          value: "connectionsMade",
          align: "start",
        },
      ],
    }
  },
  computed: {
    ...mapGetters(["currentEvent"]),
    breadCrumbItems() {
      if (this.currentEvent) {

        let items = [
          {
            text: "EventConnect",
            disabled: false,
            routeName: "MultiConnect",
            params: "",
          },
          {
            text: this.currentEvent.name,
            disabled: false,
            routeName: "editMultiConnect",
            params: {eventId: this.currentEvent.id},
            query: {tab: 5}
          },
          {
            text: 'Analytics',
            disabled: false,
            routeName: "editMultiConnect",
            params: {
              eventId: this.currentEvent.id,
            },
            query: {tab: 5}
          },
          {
            text: 'Connections',
            disabled: true,
            routeName: "connectionAnalytics",
            params: {
              eventId: this.currentEvent.id,
            },
          },
        ];
        return items;
      } else return [];
    },

    headerDetails() {
      return [
        {
          title: "connections requested",
          value: this.currentEvent.analyticsData.totalConnectionRequested,
        },
        {
          title: "connections made",
          value: this.currentEvent.analyticsData.totalConnectionsMade,
        },
      ];
    },
  },
  methods: {
    ...mapActions(["initializeCurrentEvent"]),
    handleRoute(item) {
      if (!item.disabled) {
        let route = {name: item.routeName, params: item.params};
        if (item.query) {
          route.query = item.query;
        }
        this.$router.push(route);
      }
    },
    async getConnectionDataFromAttendee(attendee) {

      const connectionsRequestedCount =  getCountFromServer(queryConnectionsCollection(
          where("businessCardIds", "array-contains", attendee.businessCardId),
          where("isAccepted", "==", false),
          where("multiConnectEventId", "==", this.currentEventId)
      ));
      const connectionsMadeCount =  getCountFromServer(queryConnectionsCollection(
          where("businessCardIds", "array-contains", attendee.businessCardId),
          where("isAccepted", "==", true),
          where("multiConnectEventId", "==", this.currentEventId)
      ));
      const attendeeBusinessCard = getBusinessCardsDoc(attendee.businessCardId);
      const response = await Promise.all([
        connectionsRequestedCount,
        connectionsMadeCount,
        attendeeBusinessCard,
      ]);
      if (response[2].data()!==undefined) {
        return {
          displayImageUrl: response[2].data().displayImageUrl,
          name: response[2].data().firstName + ' ' + response[2].data().lastName,
          businessName: response[2].data().businessName,
          jobTitle: response[2].data().jobTitle,
          connectionsRequested: response[0].data().count,
          connectionsMade: response[1].data().count,
        };
      }
    },
    async getConnectionsData() {
      let attendeesQuery = queryEventAttendeesCollection(where("eventId", "==", this.currentEventId), limit(20));
      if (this.lastLoadedDocument) {
        attendeesQuery = query(attendeesQuery, startAfter(this.lastLoadedDocument));
      }
      const attendeesSnapshot = await getDocs(attendeesQuery);
      if (attendeesSnapshot.size < 20) {
        this.canLoadMore = false;
      }
      console.log(attendeesSnapshot.size);
      this.lastLoadedDocument = attendeesSnapshot.docs[attendeesSnapshot.size - 1];
      const attendees = attendeesSnapshot.docs.map(doc => doc.data());
      const connectionsData = await Promise.all(attendees.map(attendee => this.getConnectionDataFromAttendee(attendee)));
      if (this.lastLoadedDocument) {
        connectionsData.filter(connectionData => connectionData!==undefined).forEach(connection => this.attendeeData.push(connection));
      } else {
        this.attendeeData = connectionsData.filter(connectionData => connectionData!==undefined);
      }
    },
    async saveEvent() {
      await this.initializeCurrentEvent(this.currentEventId);
      await this.getConnectionsData();
    }
  },
  created() {
    this.currentEventId = this.$route.params.eventId;
    this.saveEvent();
  }
}
</script>

<template>
  <v-container fluid :class="currentEvent == null || !this.attendeeData ? 'fill-height' : ''">
    <v-row v-if="currentEvent == null || !this.attendeeData">
      <v-col>
        <Loading/>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-breadcrumbs :items="breadCrumbItems" large>
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
                :disabled="item.disabled"
                :class="[
                'text-capitalize px-0',
                {
                  'cursor-pointer':
                    item.routeName != $route.name && !item.disabled,
                },
              ]"
                @click="handleRoute(item)"
            >
              <div
                  :class="[
                  item.routeName != $route.name && !item.disabled
                    ? 'primary--text'
                    : 'grey--text',
                  'text-subtitle ',
                ]"
              >
                {{ item.text }}
              </div>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-col>
      <v-col cols="12">
    <v-card outlined min-height="110vh" class="px-8 py-4">
      <v-card-title>
        Connections
      </v-card-title>
      <v-col>
        <v-row>
          <div v-for="item in headerDetails">
            <div style="background-color: #F6F7FC; border-radius: 6px" class="ma-4">
              <v-row class="ma-auto px-4 py-2" align="center">

                <img src="@/assets/icons/account-group.svg" height="30" width="35" style="color: black"
                     class="pr-2">{{ item.value }} {{ item.title }}
              </v-row>
            </div>
          </div>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="attendeeData"
            :items-per-page="-1"
            hide-default-footer
        >
          <template v-slot:[`item.image`]="{ item }">
            <v-avatar size="40">
              <v-img :src="item.displayImageUrl"/>
            </v-avatar>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <span>{{ item.name }}</span>
          </template>
          <template v-slot:[`item.businessName`]="{ item }">
            <span>{{ item.businessName }}</span>
          </template>
          <template v-slot:[`item.jobTitle`]="{ item }">
            <span>{{ item.jobTitle }}</span>
          </template>
          <template v-slot:[`item.connectionsRequested`]="{ item }">
            <span>{{ item.connectionsRequested }}</span>
          </template>
          <template v-slot:[`item.connectionsMade`]="{ item }">
            <span>{{ item.connectionsMade }}</span>
          </template>
        </v-data-table>
        <div class="pt-4 justify-end flex">
          <v-btn v-if="canLoadMore" @click="getConnectionsData" width="150"
                 color="primary"
                 depressed
                 large
                 class="text-body-1 fixed btn">Load more</v-btn>
        </div>

      </v-col>
    </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<style scoped>

</style>